import { render } from "./item.vue?vue&type=template&id=205f1a79&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import "./item.vue?vue&type=style&index=0&id=205f1a79&lang=scss&scoped=true"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205f1a79"]])

export default __exports__